import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEO from "@/components/SEO";
import { useLang } from "@/context/LanguageContext";
import { Building2 } from "lucide-react";
import RegistrationForm from "@/components/RegistrationForm";

export default function SupplierRegister() {
  const { lang } = useLang();
  return (
    <div className="min-h-screen bg-xd-light" data-testid="page-supplier-register">
      <SEO title="Diventa Fornitore / Partner" description="Registrati come fornitore o partner audrivio e accedi al listino con sconto dedicato. La tua richiesta viene approvata dal nostro team in 24-48h." path="/fornitori/registrati" lang={lang} noindex />
      <Header />

      <section className="bg-xd-dark text-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
          <div className="font-mono-tech text-xs uppercase tracking-widest text-xd-cyan">Programma Partner</div>
          <h1 className="font-display text-4xl sm:text-5xl font-semibold mt-2 tracking-tight">Diventa fornitore audrivio</h1>
          <p className="mt-4 text-slate-300 leading-relaxed">
            Officina, autoricambista, installatore o rivenditore? Registrati per accedere al listino con sconto dedicato applicato automaticamente ad ogni ordine.
          </p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <div className="flex items-start gap-3 mb-6">
          <Building2 className="w-8 h-8 text-xd-cyanHover shrink-0" />
          <div>
            <h2 className="font-display text-lg font-semibold">Dati aziendali</h2>
            <p className="text-xs text-xd-muted mt-0.5">Tutti i campi sono obbligatori. Verranno verificati manualmente prima dell&apos;attivazione.</p>
          </div>
        </div>

        <RegistrationForm role="supplier" />

        <p className="text-[11px] text-xd-muted text-center mt-4">
          Registrandoti accetti i nostri <Link to="/termini" className="underline">Termini</Link> e la <Link to="/privacy" className="underline">Privacy Policy</Link>. Sei già registrato? <Link to="/login" className="text-xd-cyanHover font-medium">Accedi</Link>.
        </p>
      </section>

      <Footer />
    </div>
  );
}
